<template>

  <div class="content">

    <h2>REST API Authentication</h2>

    <h3>Username 🙋‍♀️</h3>
    <p class="account-username">{{ api_username }}</p>

    <h3>Secret Key 🔑</h3>
    <div class="account-password-container">
      <div class="account-password-box"
      v-clipboard:copy="api_key"
      v-clipboard:success="handleCopyAPIKey">
        <p>{{ api_key }}</p>
      </div>
      <a-popconfirm
      title="Creating a new API key will invalidate your old API key"
      ok-text="Generate new API key"
      cancel-text="Cancel"
      @confirm="generateNewAPIKey">
        <button></button>
      </a-popconfirm>
    </div>

    <h3>See what you can do with our API</h3>

    <!-- <a href="https://docs.outsidevoice.io/reference" target="_blank"> -->
    <a href="https://outsidevoice.readme.io/reference/get_surveys-1" target="_blank">
      <a-button @click="goToDocumentation" class="documentation-btn">Visit Documentation 📙</a-button>
    </a>

    <hr>

    <h2>Webhook</h2>
    <p>Get JSON data from new survey answers as they come in.</p>

    <a-tooltip title="Please start with http:// or https://" :visible="show_webhook_format_error && !edited_webhook.includes('http')">
      <input
      v-model="edited_webhook"
      placeholder="https://route-to-your-webhook.com" maxlength="100" type="text">
    </a-tooltip>

    <button v-if="!is_verifying_webhook && edited_webhook && edited_webhook !== webhook" @click="editWebhook" class="webhook-btn">Verify and Save</button>
    <div v-if="is_verifying_webhook" class="verify-webhook-loader">
      <p>Verifying webhook</p>
      <a-spin class="spinner">
        <a-icon slot="indicator" type="loading" style="font-size: 25px; color: #1BD285;" spin />
      </a-spin>
    </div>

  </div>

</template>

<script>

export default {

  name: 'API',

  data: function () {
    return {
      edited_webhook: this.$store.state.account.private && this.$store.state.account.private.webhook ? _.clone(this.$store.state.account.private.webhook) : '',
      is_verifying_webhook: false,
      show_webhook_format_error: false
    }
  },

  computed: {

    api_username() {
      if (this.$store.state.account) {
        return this.$store.state.account.id || '';
      } else {
        return '';
      };
    },

    api_key() {
      if (this.$store.state.account && this.$store.state.account.private) {
        return this.$store.state.account.private.api_key || '';
      } else {
        return '';
      };
    },

    webhook() {
      if (this.$store.state.account && this.$store.state.account.private) {
        return this.$store.state.account.private.webhook || '';
      } else {
        return '';
      };
    },

  },

  components: {},

  methods: {

    handleCopyAPIKey() {
      this.$message.success('API Key copied to clipboard');
    },

    generateNewAPIKey() {
      this.$store.dispatch('generateNewAPIKey');
      this.$message.success('Generated new API key');
    },

    goToDocumentation() {
      console.log('goToDocumenation called');
    },

    editWebhook() {
      if (!this.edited_webhook.includes('http://') && !this.edited_webhook.includes('https://')) {
        this.show_webhook_format_error = true;
        return;
      };
      this.is_verifying_webhook = true;
      this.$axios.post(this.edited_webhook).then(res => {
        this.$message.success('Webhook set successfully');
        this.$notification['success']({
          message: 'Webhook Set',
          placement: 'bottomLeft',
          description: 'JSON data from new survey answers will now be sent to this webhook.',
        });
        this.$store.dispatch('editWebhook', this.edited_webhook);
      }).catch(err => {
        this.$notification['error']({
          message: 'Non-200 Status',
          placement: 'bottomLeft',
          description: 'Did not receive a 200 status for the POST request to this webhook',
        });
      }).finally(() => {
        this.is_verifying_webhook = false;
      });
    },

  },


  mounted() {

    // let account = this.$store.state.account;
    //
    // if (!billing) { // User has not yet been inited - the page was loaded directly.
    //   this.$store.dispatch('setBilling');
    // };

  },

  created() {
    analytics.page('API');
  }

}
</script>

<style scoped lang="scss">

.content{
  padding: 55px 5%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

h2,h3,p,button{
  color: #0D303F;
}

h2{
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 30px;
  &:last-of-type{
    margin-bottom: 20px;
  }
}

h3{
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 18px;
}

hr{

}

.account-username{
  margin-bottom: 30px;
}

.account-password-container{
  display: flex;
  justify-content: center;
  margin-bottom: 50px;
  .account-password-box{
    padding: 10px 14px;
    background-color: rgb(248,248,248);
    background-image: url("../../assets/icons/copy-icon.svg");
    background-size: 17px;
    background-position: calc(100% - 12px) 11px;
    background-repeat: no-repeat;
    padding-right: 45px;
    border: 1px solid rgb(225,225,225);
    border-radius: 4px;
    cursor: pointer;
    p{
      margin: 0;
    }
  }
  button{
    width: 43px;
    margin-left: 15px;
    background-image: url("../../assets/icons/refresh-icon.svg");
    background-size: 50%;
    background-position: center;
    background-repeat: no-repeat;
    &:focus{
      outline: none;
    }
  }
}

.documentation-btn{
  font-size: 14px;
  font-weight: 600;
  letter-spacing: .5px;
  height: 43px;
  color: white;
  background: #2c3052; /* Old browsers */
  background: -moz-linear-gradient(top, #2c3052 0%, #1e2032 100%); /* FF3.6-15 */
  background: -webkit-linear-gradient(top, #2c3052 0%,#1e2032 100%); /* Chrome10-25,Safari5.1-6 */
  background: linear-gradient(to bottom, #2c3052 0%,#1e2032 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  border-color: black;
  padding: 0px 18px 1px 20px;
  opacity: .85;
  border-radius: 6px;
  border: 1px solid rgb(210,210,210);
  box-shadow: 0 0 3px 0 rgba(0,0,0,.05);
  transition: all 0.3s ease;
  opacity: .95;
  cursor: pointer;
  &:hover{
    opacity: 1;
    background-color: rgb(250,250,250);
  }
}

hr{
  margin-top: 50px;
  margin-bottom: 50px;
  border-top: 1px solid rgb(230,230,230);
  width: 70%;
}

.webhook-btn{
  padding-left: 18px;
  padding-right: 18px;
}

.verify-webhook-loader{
  display: flex;
  align-items: center;
  margin-top: 14px;
  height: 30px;
  p{
    font-size: 14px;
    font-weight: 600;
  }
  .spinner{
    margin-left: 15px;
    transform: translateY(-5px);
  }
}


button{
  font-size: 14px;
  font-weight: 600;
  height: 43px;
  background-color: white;
  border: 1.5px solid rgb(230,230,230);
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.15s ease;
  &:hover{
    border-color: rgb(200,200,200);
  }
  &:focus{
    outline: none;
  }
}

input{
  height: 44px;
  width: 40%;
  color: #0D303F;
  text-align: center;
  padding-left: 12px;
  padding-right: 12px;
  margin-top: 10px;
  margin-bottom: 20px;
  background-color: rgb(246,246,246);
  border: 1px solid rgb(227,228,229);
  border-radius: 4px;
  &:focus{
    outline: none;
  }
}


@media only screen
and (min-device-width : 320px)
and (max-device-width : 480px) {


}

// Ipad Portrait
@media only screen and (min-device-width : 768px) and (max-device-width : 1024px) and (orientation : portrait) {

}


</style>
